import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {IVanService} from "../../../../../../domain/leasing/IVanService";
import {LeasingType} from "../../../../../../../../../server/src/base/entities/leasing/LeasingType";
import {Vans} from "../../../../../../../../../server/src/base/entities/leasing/Vans";
import {Van} from "../../../../../../../../../server/src/base/entities/leasing/Van";
import {StringPopupComponent} from "../../../../generic/popup/stringPopup/stringPopup";

@Component({
    selector: 'admin-van-edit',
    styleUrls: ['./vanEdit.scss'],
    templateUrl: './vanEdit.html'
})
export class VanEditComponent {

    @Input() type:LeasingType;
    @Output() previous:EventEmitter<void> = new EventEmitter<any>();
    @ViewChild(StringPopupComponent) platePopupComponent:StringPopupComponent;

    private vanService:IVanService;
    public vans:Vans;

    constructor(vanService: IVanService) {
        this.vanService = vanService;
        this.vans = new Vans();
    }

    ngOnInit(){
        this.vanService.Vans(this.type).then(vans => {
            this.vans = vans;
        });
    }

    private UpdateVans(){
        this.vanService.Vans(this.type).then(vans => {
            this.vans = vans;
        });
    }

    public goBack(){
        this.previous.emit();
    }

    public add(){
        this.platePopupComponent.Open("Numéro de plaque")
    }

    public remove(van:Van){
        this.vanService.Remove(van.id).then(() => {
            this.vans.Remove(van);
        });
    }

    public enable(van:Van){
        this.vanService.Enable(van.id).then(() => {
            van.enabled = true;
        });
    }

    public disable(van:Van){
        this.vanService.Disable(van.id).then(() => {
            van.enabled = false;
        });
    }

    public onPlateValidated(plate:string){
        let van:Van = new Van();
        van.type = this.type;
        van.plate = plate;
        this.vanService.Add(van).then(() => {
            this.UpdateVans();
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/leasing/presentation/vanEditComponent/vanEdit.ts